import { Label, StringUtils, Tooltip } from '@localina/core';
import { PersonIcon, TextBlockIcon } from '@localina/icons';
import React from 'react';

export type TReservationNoteKind = 'remark' | 'guest';

interface IProps {
    kind: TReservationNoteKind;
    text: string;
}

export const ReservationNoteLine: React.FC<IProps> = (props) => {
    const textRef = React.useRef<HTMLParagraphElement>(null);
    const [isTruncated, setIsTruncated] = React.useState(false);

    React.useLayoutEffect(() => {
        const element = textRef.current;
        if (!element) {
            return;
        }

        const measure = () => setIsTruncated(element.scrollWidth > element.clientWidth + 1);
        measure();

        const observer = new ResizeObserver(measure);
        observer.observe(element);
        return () => observer.disconnect();
    }, [props.text]);

    return (
        <Tooltip
            openOnHover
            stopPropagation={isTruncated}
            clickAwayMouseEvent="onPointerDown"
            popperClassName="tooltip reservation-note-tooltip"
            content={isTruncated ? <Label type="label" value={props.text} /> : ''}
        >
            <div
                className={StringUtils.combineStrings([
                    'reservation__notes__line',
                    props.kind,
                    isTruncated && 'is-truncated',
                ])}
            >
                <span className="reservation__notes__line__icon">
                    {props.kind === 'remark' ? <TextBlockIcon /> : <PersonIcon />}
                </span>
                <p ref={textRef} className="reservation__notes__line__text">
                    {props.text}
                </p>
            </div>
        </Tooltip>
    );
};
